import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class BillingDashboard {

    
    static addStripeMethod = () =>
        API.post(
            `/${storesType()}/${localStorage.getItem(
                "storeId"
            )}/general-settings/billing-dashboard/payment-methods/stripe/payment-methods`
        );

    static authenticatePayment = () =>
        API.post(
            `/${storesType()}/${localStorage.getItem(
                "storeId"
            )}/general-settings/billing-dashboard/payment-methods/stripe/authenticate-payment`
        );
        
    static getCurrent = () =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/current`
        );
        
    static updatePaymentDue = body =>
        API.put(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payment-due`, body
        );
        
        static getPaymentMethods = () =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payment-methods`
        );
        
        static getStripeMethods = () =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payment-methods/stripe/payment-methods`
        );

        static attachPaymentMethod = (body) =>
        API.put(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payment-methods/attach-payment-method`, body
        );

        static doStripeAction = (action, method) =>
        API[action](
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payment-methods/stripe/payment-methods/${method.id}${action == 'patch' ? '/activate' : ''}`,
        );
        
        static getPaymentHistory = (q) =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payments-history${q}`
        );

        static billingPayment = (billingId) =>
        API.post(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/billing/${billingId}`
        );
        
        static updatePaymentMethod = (body) =>
        API.put(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/payment-methods/update-payment-method`, body
        );
        
        static getSubscriptionPlans = (query) =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/plans/${storesType()=='stores'? 'store':'company'}-available${query}`
        );
        
        static changeSubscriptionPlan = (body) =>
            API.put(
                `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/change-plan`, body
            );

        static calculateBilling = (id) =>
            API.put(
                `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/billing/${id}`
        );

        static getEmails = () =>
            API.get(
                `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/email-notifications`
        );

        static addEmail = (body) =>
            API.post(
                `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/email-notifications`, body
        );

        static deleteEmail = (id) =>
            API.delete(
                `/${storesType()}/${localStorage.getItem("storeId")}/general-settings/billing-dashboard/email-notifications/${id}`
        );
        
}
